import React, { useState } from "react";
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Grid,
  Grid2,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
// import { Link } from 'react-router-dom';
import upLine from "../../assets/images/upload-line.svg";
import downLine from "../../assets/images/download-line.svg";
import e1 from "../../assets/images/events_1.png";
import e2 from "../../assets/images/events_2.png";
import locationSmall from "../../assets/images/location-small.svg";
import userSmall from "../../assets/images/user-small.svg";
import closeBtn from "../../assets/images/close.svg";
import qr from "../../assets/images/qr.png";
import copyClipboard from "../../assets/images/copy-clipboard.svg";
import dateSmall from "../../assets/images/date-small.svg";
import Header from "../Header";
import Footer from "../Footer";
import { Link, useNavigate } from "react-router-dom";
import HeaderBack from "../Header_Back";
import BackImage from "../../assets/images/back.svg";

const Ticketdetails = (props) => {
  const [selectedTicket, setSelectedTicket] = useState("myTicket");
  const [openModal, setOpenModal] = useState(false);
  const [openNextModal, setOpenNextModal] = useState(false);
  const [openReceivedModal, setOpenReceivedModal] = useState(false);
  const [openCopyModal, setOpenCopyModal] = useState(false); // New state for "Copy Address" modal
  const navigate = useNavigate();
  const handleTicketClick = (ticket) => setSelectedTicket(ticket);
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);
  const handleOpenNextModal = () => {
    setOpenModal(false);
    setOpenNextModal(true);
  };
  const handleBackClick = () => {
    navigate(-1);
  };
  const handleMyTicket = () => {
    navigate("/my-tickets/resell-events-details");
  };
  const events = [
    {
      id: 1,
      image: e2,
      title: "Raas Ratri : A Night of Dance and Devotion",
      user: "General Ticket, 1 Day Pass, 1 Person",
      date: "8 Oct - 18 Oct 2025, 08:00 PM - 10:00 PM",
      location:
        "123 Shree Mandir Road, Navrang Colony, Ahmedabad, Gujarat - 380001",
      link: "/dashboard/events-details",
      ticketprice: "780.00",
    },
  ];
  return (
    <Box sx={{ flexGrow: 1 }}>
      <div className="center-App" container direction="column">
        <Grid2 className="header" sx={{ background: "#6638A2" }}>
          <Grid2
            className="menu-Link"
            component={Link}
            onClick={handleBackClick}
          >
            <img src={BackImage} alt="Navbar" width={180} />
          </Grid2>
          <Typography className="categories-name">Ticket Detail</Typography>
        </Grid2>

        {/* <HeaderBack name="Ticket Detail" /> */}

        <Box sx={{ padding: "30px 30px", float: "left", width: "100%" }}>
          <div container spacing={2}>
            {events.map((event) => (
              <div item xs={12} key={event.id}>
                <Box className="">
                  <div className="position-relative ">
                    <CardMedia
                      component="img"
                      height="185"
                      image={event.image}
                      alt={event.title}
                    />
                  </div>
                  <CardContent style={{ padding: "9px 5px" }}>
                    <Typography
                      variant="h6"
                      component="div"
                      sx={{
                        color: "#6638A2",
                        marginTop: "5px",
                        fontSize: "28px",
                        marginBottom: "10px",
                        lineHeight: "32px",
                        fontWeight: "500",
                      }}
                    >
                      {event.title}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        marginTop: "11px",
                        fontSize: "16px",
                        color: "#341439",
                      }}
                    >
                      <img src={locationSmall} alt="" className="small-svg" />
                      {event.user}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        marginTop: "11px",
                        fontSize: "16px",
                        color: "#341439",
                      }}
                    >
                      <img src={userSmall} alt="" className="small-svg" />
                      {event.location}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        marginTop: "11px",
                        fontSize: "16px",
                        color: "#341439",
                      }}
                    >
                      <img src={dateSmall} alt="" className="small-svg" />
                      {event.date}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        marginTop: "7px",
                      }}
                    >
                      <span
                        style={{
                          float: "left",
                          marginTop: "10px",
                          color: "#028E54",
                          fontSize: "18px",
                          textTransform: "uppercase",
                          fontWeight: "500",
                        }}
                      >
                        Ticket Price ₹ 780.00
                      </span>
                    </Typography>
                  </CardContent>
                  <Grid2
                    className="button-bottom fullWidth"
                    fullWidth
                    sx={{ marginTop: "25px" }}
                  >
                    <Button
                      className="btn-common"
                      variant="contained"
                      color="primary"
                      fullWidth
                      onClick={handleMyTicket}
                    >
                      Click here to re-sell
                    </Button>
                  </Grid2>
                </Box>
              </div>
            ))}
          </div>
        </Box>
      </div>
    </Box>
  );
};

export default Ticketdetails;
